import styled from 'styled-components';

export const FooterContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 2.5rem;
  flex-direction: column;
  justify-content: flex-end;
`;

// Texts
export const Text = styled.p`
  font-size: 14px;
`;

export const CenterText = styled(Text)`
  text-align: center;
  margin-bottom: 20px;
  max-width: 49ch;
`;

export const Link = styled.a`
  color: black;
  font-size: 14px;
`;

export const FormTitle = styled.h3`
  margin: 0;
  text-align: center;
`;

export const FooterText = styled(Text)`
  font-size: 12px;
  font-weight: 400;
`;

// Inputs
export const FormWrapper = styled.div``;

export const FooterButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: flex-end;
  justify-content: space-between;

  width: 100%;
`;

export const InputIcon = styled.img`
  height: auto;
  width: 24px;
`;

export const EmailIcon = styled(InputIcon)`
  position: absolute;
  width: 18px;
  left: 16px;
`;

export const QuestionIcon = styled(InputIcon)`
  width: 22px;
  cursor: pointer;
`;

export const CloseIcon = styled(QuestionIcon)`
  width: 14px;
  align-self: flex-end;
`;

export const Input = styled.input`
  display: block;
  height: 35px;
  font-size: 1.4rem;
  color: #222247;

  border-radius: 7px;
  padding: 0 8px;
  border: 1px solid #dbdbdc;
  &:disabled {
    border: 1px solid transparent;
  }
`;

export const TextAreaInput = styled.textarea`
  display: block;
  font-size: 1.4rem;
  color: #222247;
  height: 50px;
  border-radius: 7px;
  padding: 0 8px;
  border: 1px solid #dbdbdc;
  &:disabled {
    border: 1px solid transparent;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 3%;
`;

export const InputLabel = styled.div`
  color: '#222247';
`;

export const StyledErrorWrap = styled.p`
  color: red;
`;
export const EnrollmentFormTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: 'center';
`;

export const EnrollmentFormContent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
  height: 500px;
  margin-top: 10px;
  padding: 0px 20px 20px 20px;
`;

export const EnrollDatePickerValidation = styled.p`
  color: red;
  font-size: 8pt;
`;

export const EnrollmentFormContentTitle = styled(Text)`
  font: normal normal bold 20px/31px Biotif;
`;
